/**
 * @fileoverview GET handler for the "/app_settings/:app_group_id/message_prioritization/has_frequency_capping_rules" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdMessagePrioritizationHasFrequencyCappingRules } from "./constants";
import type { GetMessagePrioritizationHasFrequencyCappingRulesResult } from "./types";
import { isGetMessagePrioritizationHasFrequencyCappingRulesResult } from "./validators";

/**
 * GET handler for the "/app_settings/:app_group_id/message_prioritization/has_frequency_capping_rules" endpoint
 */
export const getMessagePrioritizationHasFrequencyCappingRules = reactQueryFetcherAdapter(
  appSettingsAppGroupIdMessagePrioritizationHasFrequencyCappingRules,
  (signal: AbortSignal, appGroupId: string): Promise<GetMessagePrioritizationHasFrequencyCappingRulesResult> => {
    return fetch(
      `/app_settings/${appGroupId}/message_prioritization/has_frequency_capping_rules`,
      "GET",
      {},
      { signal },
      {
        // fail-open background check: do not display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  },
  isGetMessagePrioritizationHasFrequencyCappingRulesResult
);
